/*
 * defaultColumn.js maker 191126
 * 시트 생성 시 기본 컬럼 관리
 */

export default {
    defaultColumn() {
		let d = [
			{
				menuroute: 'receptions',
				type: 'list',
				columns:[
					{columnName: 'Rception No', columnAttr: 'receptionno', columnDivision:'O', columnType: 'STRING', codes:[]},
					{columnName: 'Create Date', columnAttr: 'createdate', columnDivision:'O', columnType: 'DATE', codes:[]},
					{columnName: 'Update Date', columnAttr: 'updatedate', columnDivision:'O', columnType: 'DATE', codes:[]},
					{columnName: 'State', columnAttr: 'statecode', columnDivision:'O', columnType: 'LIST', codes:[]},
					{columnName: 'Creator', columnAttr: 'creator', columnDivision:'O', columnType: 'STRING', codes:[]},
				]
			},
			{
				menuroute: 'samples',
				type: 'list',
				columns:[
					{columnName: 'Sample ID', columnAttr: 'sampleid', columnDivision:'O', columnType: 'STRING', codes:[]},
					{columnName: 'Barcode', columnAttr: 'samplebarcode', columnDivision:'O', columnType: 'STRING', codes:[]},
					{columnName: 'Status', columnAttr: 'statuscode', columnDivision:'O', columnType: 'LIST', codes:[]},
				]
			},
			{
				menuroute: 'experiments',
				type: 'list',
				columns:[
					{columnName: 'Experiment No', columnAttr: 'experimentno', columnDivision:'O', columnType: 'STRING', codes:[]},
					{columnName: 'Create Date', columnAttr: 'createdate', columnDivision:'O', columnType: 'DATE', codes:[]},
					{columnName: 'Update Date', columnAttr: 'updatedate', columnDivision:'O', columnType: 'DATE', codes:[]},
					{columnName: 'State', columnAttr: 'statecode', columnDivision:'O', columnType: 'LIST', codes:[]},
					{columnName: 'Creator', columnAttr: 'creator', columnDivision:'O', columnType: 'STRING', codes:[]},
				]
			},
			{
				menuroute: 'experiments',
				type: 'detail',
				columns:[
					{columnName: 'D', columnAttr: 'divisionidx', columnDivision:'O', columnType: 'STRING', codes:[]},
					{columnName: 'R', columnAttr: 'reexpidx', columnDivision:'O', columnType: 'DATE', codes:[]},
					{columnName: 'Result', columnAttr: 'experimentresultcode', columnDivision:'O', columnType: 'LIST', codes:[]},
				]
			},
			{
				menuroute: 'platinges',
				type: 'list',
				columns:[
					{columnName: 'Experiment No', columnAttr: 'platingno', columnDivision:'O', columnType: 'STRING', codes:[]},
					{columnName: 'Create Date', columnAttr: 'createdate', columnDivision:'O', columnType: 'DATE', codes:[]},
					{columnName: 'Update Date', columnAttr: 'updatedate', columnDivision:'O', columnType: 'DATE', codes:[]},
					{columnName: 'State', columnAttr: 'statecode', columnDivision:'O', columnType: 'LIST', codes:[]},
					{columnName: 'Creator', columnAttr: 'creator', columnDivision:'O', columnType: 'STRING', codes:[]},
				]
			},
			{
				menuroute: 'sequencinges',
				type: 'list',
				columns:[
					{columnName: 'Run Id', columnAttr: 'runid', columnDivision:'O', columnType: 'STRING', codes:[]},
					{columnName: '장비명', columnAttr: 'abbrid', columnDivision:'O', columnType: 'STRING', codes:[]},
					{columnName: 'State', columnAttr: 'statecode', columnDivision:'O', columnType: 'LIST', codes:[]},
				]
			},
			{
				menuroute: 'demultis',
				type: 'list',
				columns:[
					{columnName: 'Run Id', columnAttr: 'runid', columnDivision:'O', columnType: 'STRING', codes:[]},
					{columnName: '장비명', columnAttr: 'abbrid', columnDivision:'O', columnType: 'STRING', codes:[]},
					{columnName: 'State', columnAttr: 'statecode', columnDivision:'O', columnType: 'LIST', codes:[]},
				]
			},
			{
				menuroute: 'equipments',
				type: 'list',
				columns:[
					{columnName: 'Name', columnAttr: 'equipmentname', columnDivision:'O', columnType: 'STRING', codes:[]},
					{columnName: 'Class', columnAttr: 'class', columnDivision:'O', columnType: 'LIST', codes:[]},
					{columnName: 'Serial', columnAttr: 'serial', columnDivision:'O', columnType: 'STRING', codes:[]},
					{columnName: 'Path', columnAttr: 'path', columnDivision:'O', columnType: 'STRING', codes:[]},
					{columnName: 'Place', columnAttr: 'place', columnDivision:'O', columnType: 'LIST', codes:[]},
					{columnName: 'creator', columnAttr: 'Creator', columnDivision:'O', columnType: 'STRING', codes:[]},
					{columnName: 'Create Date', columnAttr: 'createdate', columnDivision:'O', columnType: 'DATE', codes:[]},
					{columnName: 'State', columnAttr: 'usedcode', columnDivision:'O', columnType: 'LIST', codes:[]},
				]
			},
			{
				menuroute: 'pipelines',
				type: 'list',
				columns:[
					{columnName: 'Name', columnAttr: 'name', columnDivision:'O', columnType: 'STRING', codes:[]},
					{columnName: 'Path', columnAttr: 'path', columnDivision:'O', columnType: 'STRING', codes:[]},
					{columnName: 'Creator', columnAttr: 'creator', columnDivision:'O', columnType: 'STRING', codes:[]},
					{columnName: 'Create Date', columnAttr: 'createdate', columnDivision:'O', columnType: 'DATE', codes:[]},
					{columnName: 'Update Date', columnAttr: 'updatedate', columnDivision:'O', columnType: 'DATE', codes:[]},
					{columnName: 'State', columnAttr: 'usedcode', columnDivision:'O', columnType: 'LIST', codes:[]},
				]
			},
			{
				menuroute: 'tests',
				type: 'list',
				columns:[
					{columnName: 'Sample ID', columnAttr: 'sampleid', columnDivision:'O', columnType: 'STRING', codes:[]},
					{columnName: 'Barcode', columnAttr: 'samplebarcode', columnDivision:'O', columnType: 'STRING', codes:[]},
					{columnName: 'Status', columnAttr: 'statuscode', columnDivision:'O', columnType: 'LIST', codes:[]},
				]
			},
			{
				menuroute: 'tests',
				type: 'detail',
				columns:[
					{columnName: 'D', columnAttr: 'divisionidx', columnDivision:'O', columnType: 'STRING', codes:[]},
					{columnName: 'R', columnAttr: 'reexpidx', columnDivision:'O', columnType: 'DATE', codes:[]},
					{columnName: 'Result', columnAttr: 'experimentresultcode', columnDivision:'O', columnType: 'LIST', codes:[]},
				]
			},
			{
				menuroute: 'results',
				type: 'list',
				columns:[
					{columnName: 'Result No', columnAttr: 'resultno', columnDivision:'O', columnType: 'STRING', codes:[]},
					{columnName: 'Task Serial', columnAttr: 'serial', columnDivision:'O', columnType: 'STRING', codes:[]},
					{columnName: 'Task', columnAttr: 'taskid', columnDivision:'O', columnType: 'STRING', codes:[]},
					{columnName: 'Complete Time', columnAttr: 'completetime', columnDivision:'O', columnType: 'DATE', codes:[]},
					{columnName: 'Data Count', columnAttr: 'count', columnDivision:'O', columnType: 'STRING', codes:[]},
					{columnName: 'Status', columnAttr: 'statecode', columnDivision:'O', columnType: 'LIST', codes:[]},
					{columnName: '비고', columnAttr: 'remarks', columnDivision:'O', columnType: 'STRING', codes:[]},
				]
			},
			{
				menuroute: 'results',
				type: 'detail',
				columns:[
					{columnName: 'Sample', columnAttr: 'sample', columnDivision:'O', columnType: 'STRING', codes:[]},
					{columnName: 'Barcode', columnAttr: 'barcode', columnDivision:'O', columnType: 'STRING', codes:[]},
					{columnName: 'Client', columnAttr: 'client', columnDivision:'O', columnType: 'STRING', codes:[]},
					{columnName: 'Institute', columnAttr: 'institute', columnDivision:'O', columnType: 'STRING', codes:[]},
					{columnName: 'Entero', columnAttr: 'entero', columnDivision:'O', columnType: 'STRING', codes:[]},
					{columnName: 'GNB', columnAttr: 'gnb', columnDivision:'O', columnType: 'STRING', codes:[]},
					{columnName: 'Observed', columnAttr: 'observed', columnDivision:'O', columnType: 'STRING', codes:[]},
					{columnName: 'Shannon', columnAttr: 'shannon', columnDivision:'O', columnType: 'STRING', codes:[]},
					{columnName: 'Disease', columnAttr: 'disease', columnDivision:'O', columnType: 'STRING', codes:[]},
					{columnName: 'Obesity', columnAttr: 'obesity', columnDivision:'O', columnType: 'STRING', codes:[]},
					{columnName: 'Living Health', columnAttr: 'livinghealth', columnDivision:'O', columnType: 'STRING', codes:[]},
					{columnName: 'Balance', columnAttr: 'balance', columnDivision:'O', columnType: 'STRING', codes:[]},
					// {columnName: 'Name', columnAttr: 'name', columnDivision:'O', columnType: 'STRING', codes:[]},
					// {columnName: 'Gender', columnAttr: 'gender', columnDivision:'O', columnType: 'STRING', codes:[]},
					// {columnName: 'Byear', columnAttr: 'byear', columnDivision:'O', columnType: 'STRING', codes:[]},
					// {columnName: 'Height', columnAttr: 'height', columnDivision:'O', columnType: 'STRING', codes:[]},
					// {columnName: 'Remarks', columnAttr: 'remarks', columnDivision:'O', columnType: 'STRING', codes:[]},
					// {columnName: 'Fastq_F(w/oPrimer)', columnAttr: 'fastqf', columnDivision:'O', columnType: 'STRING', codes:[]},
					// {columnName: 'Fastq_R(w/oPrimer)', columnAttr: 'fastqr', columnDivision:'O', columnType: 'STRING', codes:[]},
					// {columnName: 'Entero', columnAttr: 'entero', columnDivision:'O', columnType: 'STRING', codes:[]},
					// {columnName: 'DietNum', columnAttr: 'dietnum', columnDivision:'O', columnType: 'STRING', codes:[]},
					// {columnName: 'No.1 Microbiome', columnAttr: 'microbiome1', columnDivision:'O', columnType: 'STRING', codes:[]},
					// {columnName: 'No.2 Microbiome', columnAttr: 'microbiome2', columnDivision:'O', columnType: 'STRING', codes:[]},
					// {columnName: 'No.3 Microbiome', columnAttr: 'microbiome3', columnDivision:'O', columnType: 'STRING', codes:[]},
					// {columnName: 'No.4 Microbiome', columnAttr: 'microbiome4', columnDivision:'O', columnType: 'STRING', codes:[]},
					// {columnName: 'No.5 Microbiome', columnAttr: 'microbiome5', columnDivision:'O', columnType: 'STRING', codes:[]},
					// {columnName: 'No.6 Microbiome', columnAttr: 'microbiome6', columnDivision:'O', columnType: 'STRING', codes:[]},
					// {columnName: 'No.7 Microbiome', columnAttr: 'microbiome7', columnDivision:'O', columnType: 'STRING', codes:[]},
					// {columnName: 'No.8 Microbiome', columnAttr: 'microbiome8', columnDivision:'O', columnType: 'STRING', codes:[]},
					// {columnName: 'No.9 Microbiome', columnAttr: 'microbiome9', columnDivision:'O', columnType: 'STRING', codes:[]},
					// {columnName: 'No.10 Microbiome', columnAttr: 'microbiome10', columnDivision:'O', columnType: 'STRING', codes:[]},
				]
			},
			{
				menuroute: 'silva',
				type: 'list',
				columns:[
					{columnName: 'Task Serial', columnAttr: 'serial', columnDivision:'O', columnType: 'STRING', codes:[]},
					{columnName: 'Task', columnAttr: 'taskid', columnDivision:'O', columnType: 'STRING', codes:[]},
					{columnName: 'Complete Time', columnAttr: 'completetime', columnDivision:'O', columnType: 'DATE', codes:[]},
					{columnName: 'Data Count', columnAttr: 'count', columnDivision:'O', columnType: 'STRING', codes:[]},
					{columnName: 'Status', columnAttr: 'statecode', columnDivision:'O', columnType: 'LIST', codes:[]},
					{columnName: '비고', columnAttr: 'remarks', columnDivision:'O', columnType: 'STRING', codes:[]},
				]
			},
			{
				menuroute: 'qiime2',
				type: 'list',
				columns:[
					{columnName: 'Task Serial', columnAttr: 'serial', columnDivision:'O', columnType: 'STRING', codes:[]},
					{columnName: 'Task', columnAttr: 'taskid', columnDivision:'O', columnType: 'STRING', codes:[]},
					{columnName: 'Complete Time', columnAttr: 'completetime', columnDivision:'O', columnType: 'DATE', codes:[]},
					{columnName: 'Data Count', columnAttr: 'count', columnDivision:'O', columnType: 'STRING', codes:[]},
					{columnName: 'Status', columnAttr: 'statecode', columnDivision:'O', columnType: 'LIST', codes:[]},
					{columnName: '비고', columnAttr: 'remarks', columnDivision:'O', columnType: 'STRING', codes:[]},
				]
			},
			{
				menuroute: 'fungal',
				type: 'list',
				columns:[
					{columnName: 'Task Serial', columnAttr: 'serial', columnDivision:'O', columnType: 'STRING', codes:[]},
					{columnName: 'Task', columnAttr: 'taskid', columnDivision:'O', columnType: 'STRING', codes:[]},
					{columnName: 'Complete Time', columnAttr: 'completetime', columnDivision:'O', columnType: 'DATE', codes:[]},
					{columnName: 'Data Count', columnAttr: 'count', columnDivision:'O', columnType: 'STRING', codes:[]},
					{columnName: 'Status', columnAttr: 'statecode', columnDivision:'O', columnType: 'LIST', codes:[]},
					{columnName: '비고', columnAttr: 'remarks', columnDivision:'O', columnType: 'STRING', codes:[]},
				]
			},
		
		
		];
		return d;
	},
    defaultType() {
		let d = ['STRING', 'LIST', 'DATE', 'COUNT', 'COMPANY','DEPARTMENT', 'FIGURE', 'PIPELINE', 'USER', 'DATERANGE']; // 문자타입, 선택타입, 날짜타입, 숫자타입, 회사타입, 사용자타입, 수치타입, 분석타입, 날짜기간
		return d;
	},
	sheetSearch(ad){
		let d = this.defaultColumn();
		let r = []
		d.some((a)=>{
			if(a.menuroute === ad[0]){
				if(a.type === ad[1]){
					r = a;
				}
			}
		});
		return r;
	}
}



// WEBPACK FOOTER //
// ./src/views/Management/Common/defaultColumn.js